import { Overrides } from "@material-ui/core/styles/overrides";

import Palette from "./palette";

export const inputOverrides = (): Overrides => ({
  MuiOutlinedInput: {
    input: {
      "&:-webkit-autofill": {
        borderRadius: 4,
        boxShadow: `0 0 0px 1000px rgba(19, 190, 187, 0.1) inset`,
        zIndex: 0
      },
      "&:focus::placeholder": {
        color: Palette.grey[400]
      },
      color: Palette.grey[500],
      fontSize: "1.6rem",
      padding: "9px 16px",
      lineHeight: "2.4rem"
    },
    root: {
      height: "100%",
      maxHeight: "56px",
      border: `1px solid ${Palette.grey[400]}`,
      "&.MuiOutlinedInput-root.Mui-focused, .MuiOutlinedInput-root.Mui-focused:hover": {
        borderColor: Palette.info.main,
        boxShadow: "0px 0px 0px 3px rgba(1, 178, 237, 0.24)"
      },
      "& input": {
        color: Palette.grey[900],
        fontSize: "1.4rem"
      },
      "&:hover": {
        border: `1px solid ${Palette.info.main}`,
        boxShadow: "0px 0px 0px 3px rgba(1, 178, 237, 0.08)",
        "& input": {
          color: Palette.grey[900]
        },
        "&&& fieldset": {
          "&.MuiOutlinedInput-notchedOutline": {
            borderColor: "transparent",
            border: "none"
          }
        }
      },
      "&$focused": {
        outline: "none",
        "&:hover": {
          borderColor: Palette.info.main,
          boxShadow: "0px 0px 0px 3px rgba(1, 178, 237, 0.24)"
        }
      },
      "&$error": {
        border: `2px solid ${Palette.error.light}`,
        "& fieldset": {
          border: "none"
        },
        "&$focused": {
          boxShadow: "none",
          borderColor: Palette.error.light,
          "& fieldset": {
            borderColor: Palette.error.light
          },
          "&:hover": {
            boxShadow: "none"
          }
        },
        "&:hover": {
          boxShadow: "none",
          borderColor: Palette.error.light,
          borderWidth: "2px"
        },
        boxShadow: "none",
        borderColor: Palette.error.light
      }
    },
    notchedOutline: {
      border: "none"
    },
    adornedEnd: {
      paddingRight: "3.2rem"
    }
  },
  MuiInputLabel: {
    root: {
      color: Palette.grey[600],
      fontSize: "14px",
      "&&$focused": {
        "&:not($error)": {
          color: Palette.info.main
        },
        "&$error": {
          color: "#FD0045"
        }
      },
      "&.MuiFormLabel-filled": {
        "&:not($error)": {
          color: Palette.info.main
        },
        "&$error": {
          color: "#FD0045"
        }
      },
      "&$error": {
        color: "#696969"
      }
    }
  },
  MuiTextField: {
    root: {
      "& .MuiOutlinedInput-input": {
        paddingTop: "28px",
        "&:-webkit-autofill": {
          boxShadow: "0 0 0px 1000px #FFFFFF inset"
        }
      }
    }
  }
});
